<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Aufträge</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table style="width: 70vw;"
                  :headers="headers"
                  :items="contracts.items.items"
                  :rows-per-page-items="[5,10,20,50,100]"
                  :loading="isLoading"
                  :total-items="totalItems"
                  :must-sort="true"
                  :pagination.sync="pagination"
                  class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr :class="{ 'deleted': props.item.deleted, 'finished': props.item.done }"
            @click="rowClicked(props.item)">
          <td class="text-xs-left">{{ props.item.absa }}</td>
          <td class="text-xs-left">{{ props.item.contractNumber }}</td>
          <td class="text-xs-left">{{ props.item.loadno }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showDetail" transition="dialog-bottom-transition" max-width="400px">
      <ContractDetail :contract="selectedContract"></ContractDetail>
    </v-dialog>
  </div>
</template>

<script>
import ContractDetail from './ContractDetail.vue';
export default {
  name: 'contracts',
  components: {
    ContractDetail: ContractDetail
  },
  data() {
    return {
      totalItems: 0,
      showDetail: false,
      selectedContract: {},
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'loadno'
      },
      headers: [
        {
          text: 'Absatzstätte',
          align: 'left',
          sortable: true,
          value: 'absa'
        },
        {
          text: 'Auftragsnummer',
          align: 'left',
          sortable: true,
          value: 'contractNumber'
        },
        {
          text: 'Ladeschein',
          align: 'left',
          sortable: true,
          value: 'loadno'
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    contracts(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalItems = newValue.items.total;
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    contracts() {
      return this.$store.state.contracts.all;
    },
    isLoading() {
      return this.$store.state.contracts.loading;
    }
  },
  methods: {
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('contracts/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    },
    rowClicked(contract) {
      console.log(contract);
      this.selectedContract = contract;
      this.showDetail = true;
    }
  }
};
</script>
<style scoped>
.deleted {
  background-color: lightcoral;
}
.finished {
  background-color: lightgreen;
}
</style>
